import axios from 'axios';

/**
 * Tooling for behat to know if there are any pending ajax requests.
 *
 * {@see BrowserWaitContext.iWaitForAxiosRequestToFinish}
 */

declare global {
  interface Window {
    pendingAxiosRequest: number;
  }
}

window.pendingAxiosRequest = 0;

function increasePending() {
  window.pendingAxiosRequest += 1;
}

function decreasePending() {
  if (window.pendingAxiosRequest === 0) {
    return;
  }
  window.pendingAxiosRequest -= 1;
}

axios.interceptors.request.use((config) => {
  increasePending();
  // show loader
  return config;
});

axios.interceptors.response.use(
  async (response) => {
    decreasePending();
    return response;
  },
  (error) => {
    decreasePending();
    return Promise.reject(error);
  },
);
